import React from 'react';

import {PublicUserReportScreen} from 'features/userReports';

const PublicUserReportPage: React.FC = () => {
    return <PublicUserReportScreen/>;
};

export default PublicUserReportPage;
